import EventViewSlider from './EventViewSlider';

export default EventViewSlider;
